module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/adjust-cells-value/adjust-cells-value.component.css
// module id = ./src/app/shared/components/adjust-cells-value/adjust-cells-value.component.css
// module chunks = main